import React from "react";

export default function HeadquartersMetricCard({
  label,
  value,
  subtext,
  children,
  style = {},
}) {
  return (
    <div
      style={{
        background: "#0b1f35",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 12,
        padding: 18,
        minHeight: 92,
        ...style,
      }}
    >
      {label && (
        <div
          style={{
            color: "#9fb0c3",
            fontSize: 13,
            marginBottom: 8,
          }}
        >
          {label}
        </div>
      )}

      {value !== undefined && value !== null && (
        <div
          style={{
            fontSize: 28,
            fontWeight: 900,
            color: "#ffffff",
            lineHeight: 1.1,
          }}
        >
          {value}
        </div>
      )}

      {subtext && (
        <div
          style={{
            color: "#9fb0c3",
            fontSize: 13,
            marginTop: 8,
          }}
        >
          {subtext}
        </div>
      )}

      {children}
    </div>
  );
}
